import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

// Generate or get a stable anonymous session ID
const getSessionId = () => {
  let id = localStorage.getItem('fabrikov_session_id');
  if (!id) {
    id = `s_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
    localStorage.setItem('fabrikov_session_id', id);
  }
  return id;
};

// Hook that tracks every route change + sends heartbeat every 60s for "online users" metric
export const useVisitorTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Skip admin pages
    if (location.pathname.startsWith('/admin')) return;
    
    const trackVisit = async () => {
      try {
        await axios.post('/api/track', {
          session_id: getSessionId(),
          path: location.pathname,
          referrer: document.referrer || '',
          screen_width: window.innerWidth || 0,
        });
      } catch (e) {
        // Silently ignore tracking errors
      }
    };
    
    trackVisit();
    
    // Heartbeat every 60s for online users count
    const interval = setInterval(trackVisit, 60000);
    return () => clearInterval(interval);
  }, [location.pathname]);
};
